import memoize from 'lodash/memoize'

import { FilterOperator } from 'common/filter/filterConstants'
import { AnyFilter, FilterSourceType } from 'common/filter/interfaces'

export function getDefaultFilter(defaultFilters?: Nullable<AnyFilter>): AnyFilter {
  if (defaultFilters) {
    return defaultFilters
  }

  return {
    operator: FilterOperator.AND,
    groups: [
      {
        operator: FilterOperator.AND,
        items: [],
      },
    ],
  }
}

export const getDefaultFilterState = memoize((source: FilterSourceType) => {
  return {
    action: null,
    source,
    value: getDefaultFilter(),
    isInitialized: false,
  }
})
